/* tslint:disable */
/* eslint-disable */
/**
 * MINDD SCAN2 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { RecFile } from '../model';
// @ts-ignore
import type { RecFileIds } from '../model';
// @ts-ignore
import type { Type } from '../model';
/**
 * RecFileControllerApi - axios parameter creator
 * @export
 */
export const RecFileControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RecFileIds} recFileIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFiles: async (recFileIds: RecFileIds, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recFileIds' is not null or undefined
            assertParamExists('deleteFiles', 'recFileIds', recFileIds)
            const localVarPath = `/rec-files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recFileIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFile: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadFile', 'id', id)
            const localVarPath = `/rec-files/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subjectId 
         * @param {Type} sensorType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFiles: async (subjectId: string, sensorType: Type, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjectId' is not null or undefined
            assertParamExists('searchFiles', 'subjectId', subjectId)
            // verify required parameter 'sensorType' is not null or undefined
            assertParamExists('searchFiles', 'sensorType', sensorType)
            const localVarPath = `/rec-files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (subjectId !== undefined) {
                localVarQueryParameter['subjectId'] = subjectId;
            }

            if (sensorType !== undefined) {
                localVarQueryParameter['sensorType'] = sensorType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Type} sensorType 
         * @param {string} userId 
         * @param {string} deviceSerial 
         * @param {string} recordingStartTime 
         * @param {string} recordingEndTime 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile: async (sensorType: Type, userId: string, deviceSerial: string, recordingStartTime: string, recordingEndTime: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sensorType' is not null or undefined
            assertParamExists('uploadFile', 'sensorType', sensorType)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('uploadFile', 'userId', userId)
            // verify required parameter 'deviceSerial' is not null or undefined
            assertParamExists('uploadFile', 'deviceSerial', deviceSerial)
            // verify required parameter 'recordingStartTime' is not null or undefined
            assertParamExists('uploadFile', 'recordingStartTime', recordingStartTime)
            // verify required parameter 'recordingEndTime' is not null or undefined
            assertParamExists('uploadFile', 'recordingEndTime', recordingEndTime)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadFile', 'file', file)
            const localVarPath = `/rec-files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (sensorType !== undefined) { 
                localVarFormParams.append('sensorType', sensorType as any);
            }
    
            if (userId !== undefined) { 
                localVarFormParams.append('userId', userId as any);
            }
    
            if (deviceSerial !== undefined) { 
                localVarFormParams.append('deviceSerial', deviceSerial as any);
            }
    
            if (recordingStartTime !== undefined) { 
                localVarFormParams.append('recordingStartTime', recordingStartTime as any);
            }
    
            if (recordingEndTime !== undefined) { 
                localVarFormParams.append('recordingEndTime', recordingEndTime as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecFileControllerApi - functional programming interface
 * @export
 */
export const RecFileControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecFileControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {RecFileIds} recFileIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFiles(recFileIds: RecFileIds, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFiles(recFileIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecFileControllerApi.deleteFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFile(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFile(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecFileControllerApi.downloadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subjectId 
         * @param {Type} sensorType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFiles(subjectId: string, sensorType: Type, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RecFile>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFiles(subjectId, sensorType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecFileControllerApi.searchFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Type} sensorType 
         * @param {string} userId 
         * @param {string} deviceSerial 
         * @param {string} recordingStartTime 
         * @param {string} recordingEndTime 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFile(sensorType: Type, userId: string, deviceSerial: string, recordingStartTime: string, recordingEndTime: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(sensorType, userId, deviceSerial, recordingStartTime, recordingEndTime, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecFileControllerApi.uploadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RecFileControllerApi - factory interface
 * @export
 */
export const RecFileControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecFileControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {RecFileIds} recFileIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFiles(recFileIds: RecFileIds, options?: any): AxiosPromise<void> {
            return localVarFp.deleteFiles(recFileIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFile(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.downloadFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subjectId 
         * @param {Type} sensorType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFiles(subjectId: string, sensorType: Type, options?: any): AxiosPromise<Array<RecFile>> {
            return localVarFp.searchFiles(subjectId, sensorType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Type} sensorType 
         * @param {string} userId 
         * @param {string} deviceSerial 
         * @param {string} recordingStartTime 
         * @param {string} recordingEndTime 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(sensorType: Type, userId: string, deviceSerial: string, recordingStartTime: string, recordingEndTime: string, file: File, options?: any): AxiosPromise<RecFile> {
            return localVarFp.uploadFile(sensorType, userId, deviceSerial, recordingStartTime, recordingEndTime, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecFileControllerApi - object-oriented interface
 * @export
 * @class RecFileControllerApi
 * @extends {BaseAPI}
 */
export class RecFileControllerApi extends BaseAPI {
    /**
     * 
     * @param {RecFileIds} recFileIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecFileControllerApi
     */
    public deleteFiles(recFileIds: RecFileIds, options?: RawAxiosRequestConfig) {
        return RecFileControllerApiFp(this.configuration).deleteFiles(recFileIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecFileControllerApi
     */
    public downloadFile(id: string, options?: RawAxiosRequestConfig) {
        return RecFileControllerApiFp(this.configuration).downloadFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subjectId 
     * @param {Type} sensorType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecFileControllerApi
     */
    public searchFiles(subjectId: string, sensorType: Type, options?: RawAxiosRequestConfig) {
        return RecFileControllerApiFp(this.configuration).searchFiles(subjectId, sensorType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Type} sensorType 
     * @param {string} userId 
     * @param {string} deviceSerial 
     * @param {string} recordingStartTime 
     * @param {string} recordingEndTime 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecFileControllerApi
     */
    public uploadFile(sensorType: Type, userId: string, deviceSerial: string, recordingStartTime: string, recordingEndTime: string, file: File, options?: RawAxiosRequestConfig) {
        return RecFileControllerApiFp(this.configuration).uploadFile(sensorType, userId, deviceSerial, recordingStartTime, recordingEndTime, file, options).then((request) => request(this.axios, this.basePath));
    }
}

